module.exports = __webpack_public_path__ + "media/Overall Guide to Your CDH Benefits Video.be8796c0.mp4";